<template>
    <div>
        <div class="card">
            <div class="card-header text-black p-2">Projects</div>
            <div class="card-body p-2">
                <div class="overflow-auto" style="max-height: 300px;">
                    <table class="table hm-fs-12 align-middle table-hover table-sm mb-0">
                        <thead>
                            <tr class="sticky-top">
                                <th class="bg-theme">Project Name</th>
                                <th class="bg-theme">Staff</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-if="Object.keys(projects).length > 0"
                                v-for="(project, index) in projects"
                                :key="index"
                                @click="$goToPage(`/admin/projects/${project?.id}`)"
                                class="cursor-pointer"
                            >
                                <td class="text-capitalize">{{ project?.name }}</td>
                                <td class="text-capitalize">
                                    <template
                                        v-if="Object.keys(project.users).length > 0"
                                        v-for="(user, userIndex) in project.users"
                                    >
                                        <div v-if="user.user && user.first_name != ''">
                                            {{ user.user.first_name }}
                                        </div>
                                    </template>
                                    <template v-else>N/A</template>
                                </td>
                            </tr>
                            <tr v-else-if="isLoadingProjects">
                                <td colspan="2" class="text-center">Loading...</td>
                            </tr>
                            <tr v-else>
                                <td colspan="2" class="text-center">No pending projects found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProjectSummary',
    props: {},
    components: {
    },
    data() {
        return {
            projects: [],
            isLoadingProjects: true,
        };
    },
    mounted() {
        this.getProjects();
    },
    methods: {
        getProjects() {
            let self = this;
            axios.post('/admin/dashboard/stats?action=projects', {action: 'projects'})
                .then(response => {
                    self.projects = response.data;
                    self.isLoadingProjects = false;
                })
        },
    },
};
</script>
